<div class="MarkNotBillableDialog" [formGroup]="inputForm">
  <p class="mb-3">
    Choose how this account is billed outside Stripe. Off-app billed accounts do not need a Stripe
    subscription, and Update Credit Card is hidden for the user.
  </p>
  <div class="row">
    <div class="col col-12 col-sm-4 d-flex align-items-center">
      <mat-label>Billing designation</mat-label>
    </div>
    <div class="col col-12 col-sm-8">
      <app-select
        label="Select designation"
        [items]="designationItems"
        formControlName="billing_designation"
      ></app-select>
    </div>
  </div>
  <div class="row mt-3" *ngIf="showInvoiceNote">
    <div class="col col-12 col-sm-4 d-flex align-items-center">
      <mat-label>Invoice note</mat-label>
    </div>
    <div class="col col-12 col-sm-8">
      <app-text-field formControlName="invoice_note" placeholder="Invoice note (required)"></app-text-field>
    </div>
  </div>
</div>
